import request from '@/utils/request'
import URL from './urlTranslator'

export function getDeptByUuid(uuid) {
  const params = { uuid }
  return request({
    url: `${URL.sys.dept}`,
    method: 'get',
    params
  })
}

export function delDeptByUuid(uuid) {
  const params = { uuid }
  return request({
    url: `${URL.sys.dept}`,
    method: 'delete',
    params
  })
}

export function saveDept(data) {
  return request({
    url: URL.sys.dept,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function getAllDept() {
  return request({
    url: URL.sys.getAllDept,
    method: 'get'
  })
}
